import TransfersStatsPanel from './TransfersStatsPanel';

export default TransfersStatsPanel;
